module.exports = __webpack_public_path__ + "img/service (2).a6dab7ca.png";